import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import ja from "./locales/ja.json";
import zh from "./locales/zh.json";

const resources = {
  ja: {
    translation: ja,
  },
  en: {
    translation: en,
  },
  zh: {
    translation: zh,
  },
};

const savedLanguage = localStorage.getItem("language");

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage || "ja",
  fallbackLng: "ja",
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
  returnNull: false,
  returnEmptyString: false,
});

export default i18n;
